import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/chivo/700.css';
import '@fontsource/chivo/900.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);